import {
  Accordion,
  RadioButtonField,
  RadioButtonGroup,
} from '@sunwebgroup/ui-components/uds'
import { isEmpty } from 'ramda'
import { useIntl } from '@/intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createSearchFilterClickEvent } from '../../../../domain/analytics'
import { useFilters, useSelectFilter } from '../../../../domain/hooks'
import { FilterGroupProps } from '../types'

export function TransportTypeFilter({ defaultOpen }: FilterGroupProps) {
  const intl = useIntl()
  const { sendEvent } = useAnalytics()
  const { options, selectedValue, setSelection, isFetching } = useSelectFilter('TransportType')
  const { resetOptionalFilters } = useFilters()

  const handleFilterChange = (value: string) => {
    resetOptionalFilters()
    setSelection(value)
    sendEvent(
      createSearchFilterClickEvent({
        element: 'radio button',
        type: 'transport',
        result: value,
      }),
    )
  }

  if (isEmpty(options))
    return null

  return (
    <Accordion.Item title={intl.formatMessage({ id: 'transport_type_label' })} defaultOpen={defaultOpen} data-qa="transport-type-filter">
      <RadioButtonGroup
        onValueChange={handleFilterChange}
        defaultValue={selectedValue ?? undefined}
        value={selectedValue}
      >
        {options.map(({ name, value }) => (
          <RadioButtonField
            value={value}
            key={value}
            label={name}
            id={`transport-type-filter-${value}`}
            disabled={isFetching}
            data-qa="transport-type-filter-option"
            data-qa-value={value?.toLowerCase()}
          />
        ))}
      </RadioButtonGroup>
    </Accordion.Item>
  )
}
